import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationCloseReason } from 'sdk/index';
import React, { FC, ReactElement, useState } from 'react';
import { RoutePaths } from 'helpers/constants/RoutePaths';
import { history } from 'helpers/History';
import { StoreModel } from '../../models/Index';
import { inject } from 'mobx-react';
import { Services } from 'helpers/constants/Services';
import { HomeIcon } from 'assets/icons';
import { ThemeType } from 'interfaces';

interface ButtonProps extends WithTranslation {}
interface ButtonPropsInjected extends ButtonProps {
    Store: StoreModel;
}

const useStyles = makeStyles({
    homeButton: {
        height: '88px',
        width: '400px',
        border: (theme: ThemeType) => `2px solid ${theme.footer.borderColor}`,
        backgroundColor: (theme: ThemeType) => theme.footer.backgroundColor,
        color: (theme: ThemeType) => theme.footer.fontColor,
        '&:hover': {
            border: (theme: ThemeType) =>
                `2px solid ${theme.footer.borderColor}`,
            backgroundColor: (theme: ThemeType) => theme.footer.backgroundColor,
            color: (theme: ThemeType) => theme.footer.fontColor,
        },
    },
});

const HomeButton: FC<ButtonProps> = (props): ReactElement => {
    const [isClosingApp, setIsClosingApp] = useState(false);

    const { Store, t } = props as ButtonPropsInjected;
    const { billpay, sdk, deviceProfile } = Store;
    const classes = useStyles(deviceProfile.theme);

    const handleHomeButtonClick = () => {
        if (billpay.isProcessingCash) {
            console.warn("Can't go home, since cash is currently processing");
            return;
        }
        setIsClosingApp(true);

        sdk.closeApp(ApplicationCloseReason.HomeButtonClick)
            .finally(() => {
                setIsClosingApp(false);
            })
            .then(() => {
                history.push({
                    pathname: RoutePaths.IdleScreen,
                    search: history.location.search,
                });
                billpay.reset();
            });
    };

    return (
        <Button
            disabled={isClosingApp}
            className={classes.homeButton}
            onClick={handleHomeButtonClick}
            variant='secondary'
            endIcon={<HomeIcon color={deviceProfile.theme.footer.fontColor} />}
        >
            {t('Back to Main menu')}
        </Button>
    );
};

export default inject(Services.STORE)(withTranslation()(HomeButton));
